import React from 'react';
import cx from 'classnames';
// import PropTypes from 'prop-types'
import { TextAreaStyled } from './styled';

const TextArea = ({ theme_standard, label, errors, disabled, ...props }) => {
  const customClass = cx({
    theme_standard: theme_standard,
  });
  return (
    <TextAreaStyled disabled={disabled}>
      <div className={customClass}>
        {label && <div className="label">{label}</div>}
        <textarea {...props} disabled={disabled} />
        {errors && <div className="errors">{errors}</div>}
      </div>
    </TextAreaStyled>
  );
};

TextArea.propTypes = {};

export default TextArea;
